mutation CreateMatchCampaign($matchCampaignInput: MatchCampaignInput!) {
  createMatchCampaign(input: { matchCampaignInput: $matchCampaignInput }) {
    matchCampaign {
      id
    }
  }
}
